// Central brand config — edit WhatsApp number, Instagram, contact & store details here.
export const SITE = {
  name: "Adam's The Islamic Boutique",
  short: "ADAM'S",
  tagline: "Modesty, Redefined.",
  // 👇 Edit this WhatsApp number (international format, no + or spaces)
  whatsapp: "917800700798",
  whatsappDisplay: "+91 78007 00798",
  instagram: "adams_theboutique",
  instagramUrl: "https://www.instagram.com/adams_theboutique",
  email: "adamstheislamicboutique@gmail.com",
  phone: "+91 78007 00798",
};

export const NAV_LINKS = [
  { name: "Home", path: "/" },
  { name: "New Arrivals", path: "/new-arrivals" },
  { name: "Abayas", path: "/category/abayas" },
  { name: "Hijabs", path: "/category/hijabs" },
  { name: "Jilbabs", path: "/category/jilbabs" },
  { name: "Accessories", path: "/category/accessories" },
  { name: "Hajj & Umrah", path: "/hajj-umrah" },
  { name: "Sale", path: "/sale" },
  { name: "About Us", path: "/about" },
  { name: "Contact", path: "/contact" },
];

export const CATEGORIES = [
  { key: "abayas", name: "Abayas", image: "https://images.unsplash.com/photo-1772474587292-08b3e8932acd?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { key: "hijabs", name: "Hijabs", image: "https://images.unsplash.com/photo-1574297500578-afae55026ff3?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { key: "jilbabs", name: "Jilbabs", image: "https://images.pexels.com/photos/8911579/pexels-photo-8911579.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800" },
  { key: "partywear", name: "Partywear Hijabs", image: "https://images.unsplash.com/photo-1668028563825-f3b7138db3de?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { key: "accessories", name: "Accessories", image: "https://images.unsplash.com/photo-1680789527271-f1fc1528f27e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
  { key: "hajj-umrah", name: "Hajj & Umrah", image: "https://images.unsplash.com/photo-1736240624842-c13db7ba4275?crop=entropy&cs=srgb&fm=jpg&q=85&w=800" },
];

export const STORES = [
  { name: "Anna Nagar", city: "Chennai", address: "F37/38, Dee Cee Towers, Chinthamani, 2nd Avenue, Anna Nagar, Chennai 600102", phone: "+91 78007 00798", hours: "10:30 AM – 9:00 PM", maps: "https://www.google.com/maps/search/?api=1&query=Dee+Cee+Towers+Chinthamani+2nd+Avenue+Anna+Nagar+Chennai+600102" },
  { name: "Purasaiwalkam", city: "Chennai", address: "Purasaiwalkam High Road, Chennai, Tamil Nadu 600007", phone: "", hours: "10:30 AM – 9:00 PM", maps: "https://www.google.com/maps/search/?api=1&query=Purasaiwalkam+Chennai" },
  { name: "Triplicane", city: "Chennai", address: "Triplicane High Road, Chennai, Tamil Nadu 600005", phone: "", hours: "10:30 AM – 9:00 PM", maps: "https://www.google.com/maps/search/?api=1&query=Triplicane+Chennai" },
  { name: "Commercial Street", city: "Bengaluru", address: "Commercial Street, Bengaluru, Karnataka 560001", phone: "", hours: "11:00 AM – 9:30 PM", maps: "https://www.google.com/maps/search/?api=1&query=Commercial+Street+Bengaluru" },
];
